import { render, staticRenderFns } from "./Wellbeing1.vue?vue&type=template&id=92b43f32&scoped=true"
import script from "./Wellbeing1.vue?vue&type=script&lang=js"
export * from "./Wellbeing1.vue?vue&type=script&lang=js"
import style0 from "./Wellbeing1.vue?vue&type=style&index=0&id=92b43f32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b43f32",
  null
  
)

export default component.exports